function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "ico/arrow");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "ico/arrow",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("polygon", {
  id: "Path",
  fill: "currentColor",
  fillRule: "nonzero",
  transform: "translate(16.000000, 15.550054) rotate(-270.000000) translate(-16.000000, -15.550054) ",
  points: "16.011669 21.0768932 16.0116762 21.1001076 16 21.0884968 15.9883238 21.1001076 15.988331 21.0768932 6.9883238 12.127266 9.1036818 10 16 16.8577141 22.8963182 10 25.0116762 12.127266 16.011669 21.0768932"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/chevronRight.e61e4377.svg";
export { SvgComponent as ReactComponent };